<template>
  <div id="gooimeer">
    <b-container class="calculator">
      <b-row class="mt-3 mb-5">
          <b-col class="text-right"><img width="50%" src="./assets/GooimeerLogo.png" alt="Logo Gooimeer" title="Logo Gooimeer"></b-col>
      </b-row>
    </b-container>
    <Calculator layout="gooimeer" :languages="languages" />
  </div>
</template>

<script>
  export default{
    props : ['languages'],
    components: {

    },
    name: 'Gooimeer',
    data(){
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style>
  .calculator{
    max-width: 768px;
  }

  .card-header .btn{
    text-align: left;
  }
  .card-header span{
    float: right;
  }

  .btn{
    border-radius: 0px;
  }

  .spccButton{
    border: 1px solid #024788;
    background: #024788;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 1px 0 #444444;
  }

  .initialColor{
    background-color: #66a4e3;
    color: #FFFFFF;
    border: 0px solid #ddd;
  }

  .initialColor:hover{
    background-color: #024788;
    color: #FFFFFF;
  }

  .list, .card{
    width: 100%;
    min-width: 100%;
  }

  h1,h2,h3{
    color: #333;
    width: 100%;
  }
  .resultTable th:first-child, .resultTable td:first-child{
    padding-right: 5px;
    width: 300px;
  }
  .resultTable th:nth-child(2), .resultTable td:nth-child(2), .resultTable th:nth-child(3), .resultTable td:nth-child(3){
    text-align: right;
  }
  .invalid{
    border: red 2px solid;
  }
  .invalidSmall{
    border-left: red 3px solid;
  }

  .loading{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: #FFF;
  }

  .loading .row {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background: #FFF;
  }

  .loadingText{
    z-index: 999999999;
    font-size: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/Gooimeer.vue